// extracted by mini-css-extract-plugin
module.exports = {"container":"_6eb00b8e53--container--2TRmy"};